import * as React from 'react';
import './Pill.scss';

type PillProps = {
    label: string;
    active?: boolean;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    children?: React.ReactNode;
    className?: string;
    size?: 'medium' | 'small';
};

const Pill: React.FC<PillProps> = ({
    label,
    active = false,
    onClick,
    onMouseEnter,
    onMouseLeave,
    children,
    className = '',
    size = 'medium'
}) => {
    const pillClass = `shared-pill ${active && 'active'} ${size} ${
        className && className
    }`;

    return (
        <button
            className={pillClass}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            type="button"
        >
            {children}
            {label}
        </button>
    );
};

export default Pill;
